import { Action } from "../../../actions/actions";
import { AuthActionTypes } from "../actions/actionTypes";

const initialState: boolean = false;

export function submittingRecoverReducer(state = initialState, action: Action) {
    switch (action.type) {
        case AuthActionTypes.RECOVER:
            return !state;
        case AuthActionTypes.RECOVER_SUCCESS:
        case AuthActionTypes.RECOVER_FAIL:
            return !state;
        default:
            return state;
    }
}
